<template>
  <b-container>
    <!-- Fenêtre importation mandat format pdf -->
    <b-modal 
      v-model="isVisible" 
      size="lg" 
      centered 
      hide-footer 
      no-close-on-backdrop 
      no-close-on-esc
      @hide="onCancel"
      :title="modalTitle">
      <b-tabs v-model="stepIndex" nav-class="d-none">
        <!-- ETAPE IMPORTATION -->
        <b-tab title="Importation" active>
          <!-- Validateur formulaire -->
          <ValidationObserver v-slot="{ valid }">
            <b-form class="p-3">
              <b-col class="text-center mb-4">
                <h5>{{ $t('ImportSignedDocument') }}</h5>
                <p class="text-muted">{{ $t('SelectPdfDescription') }}</p>
              </b-col>
              <!-- Validateur champ import fichier -->
              <ValidationProvider name="Certificate File" rules="required" v-slot="{ errors, validate }">
                <b-form-group :label="$t('CertificateFile')" label-for="cert-file" :invalid-feedback="errors[0]">
                  <!-- INPUT D'INTEGRATION MANDAT PDF -->
                  <b-form-file
                    id="cert-file"
                    v-model="uploadedFile"
                    multiple
                    :placeholder="$t('ChooseAFile')"
                    :drop-placeholder="$t('DropFileHere')"
                    accept="application/pdf"
                    @change="handleFileChange($event); validate($event)"
                    required/>
                </b-form-group>
              </ValidationProvider>
              <b-col class="d-flex justify-content-end align-items-center mt-5">
                <!-- ANNULATION IMPORTATION -->
                <b-button @click="onCancel" variant="outline-secondary" pill class="mr-2">
                  {{ $t('Cancel') }}
                </b-button>
                <!-- VALIDATION IMPORTATION -->
                <b-button 
                  @click="goToValidationStep" 
                  :disabled="!valid || !uploadedFile" 
                  variant="primary" 
                  pill>
                  {{ $t('Next') }}
                </b-button>
              </b-col>
            </b-form>
          </ValidationObserver>
        </b-tab>
        <!-- ETAPE VALIDATION -->
        <b-tab :title="$t('Validation')">
          <PasswordValidation
            @Submit="onFinalSubmit"
            @Back="stepIndex--"
            :is-sending="isSending"/>
        </b-tab>
      </b-tabs>
    </b-modal>
  </b-container>
</template>

<script lang="ts">
/**
 * Composants Vue
 */
import { Component } from 'vue-property-decorator';

/**
 * Composant validation formulaire
 */
import { ValidationObserver, ValidationProvider } from 'vee-validate';

/**.
 * Traducation
 */
import locale from '../../locales/SMA.json';

/**
 * Classes et énumérations
 */
import { CertificateValidation } from './CertificateValidation';

/**
 * Composant pour submit du mot de passe
 */
import PasswordValidation from './PasswordValidation.vue';

@Component({
    components: {
        ValidationObserver,
        ValidationProvider,
        PasswordValidation
    },
    i18n: { messages: locale }
})
export default class ImportSignedCertificate extends CertificateValidation {
    
  // --- Computed ---
  get modalTitle() {
      switch(this.stepIndex) {
          case 0: return this.$t('ImportDocument');
          case 1: return this.$t('Validation');
          default: return "";
      }
  }

  // --- Méthodes de Navigation ---

  /**
   * Passage à l'étape de validation
   */
  private goToValidationStep() {
    if (this.uploadedFile) {
        this.stepIndex++;
    }
  }

  /**
   * Gestion du changement de fichier
   * On assigne le fichier localement. Il sera poussé dans la classe parent au moment de la sauvegarde.
   */
  private handleFileChange(event: any) {
    const file = event.target.files[0];
    
    if (file && file.type === 'application/pdf') {
      this.uploadedFile = [file];
    } else {
      this.uploadedFile = [];
      this.showToast(this.$t('PleaseSelectAValidFormat').toString(), "warning", "InvalidFormatUsePdf");
    }
  }

  /**
   * Soumission finale déclenchée par le composant PasswordValidation
   * @param password Le mot de passe saisi
   */
  private async onFinalSubmit(password: string) {
    this.signedPdfBlob = this.uploadedFile; 
    
    try {
      await this.saveCustomerSignature(password);
    } catch (error) {
      console.error("Erreur lors de la sauvegarde", error);
    }
  }

  /**
   * Annulation et fermeture
   */
  private onCancel(): void {
    this.uploadedFile = [];
    this.stepIndex = 0;
    this.isVisible = false;
    this.$emit("cancel");
  }

  /**
   * Chargement du composant
   */
  mounted(){
    this.init();
  }
}
</script>

<style scoped>
/* Cache la navigation par onglets par défaut pour gérer la navigation via les boutons */
::v-deep .nav-tabs {
    display: none !important; 
}
</style>